<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-height="680"
    scrollable
    :fullscreen="$vuetify.display.xs"
    :width="$vuetify.display.smAndUp ? 600 : 'auto'"
    style="z-index: 1100 !important;"
  >
    <v-card v-cloak>
      <v-card-title class="d-flex justify-space-between">
        {{ $t('console.connectTennant') }}

        <v-btn icon @click="dialog = false;">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text scrollable class="scrollable mt-4">
        <v-form @submit.prevent="submitForm" ref="form">
          <div class="mt-4">
            <p>
              {{ $t('console.connectTenantDescription') }}
            </p>
            <v-text-field
              v-model="connectionCodeInput"
              :label="$t('console.connectionCode')"
              :placeholder="$t('console.connectionCode')"
              :rules="connectionCodeInputRules"
              variant="solo-filled"
              hide-details="auto"
              block
              flat
              data-cy="tenantAdminEmailInput"
            />
          </div>

          <div v-if="errorMessage" class="bg-error my-2" data-cy="-----">
            {{ errorMessage }}
          </div>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn type="submit" class="bg-primary" elevation=0 @click="submitForm()"
               v-bind:loading="isSubmitted" v-bind:disabled="isSubmitted">
          {{ $t('console.acceptRequest') }}
        </v-btn>
        <v-btn variant="text" @click="dialog = false">{{ $t('common.close') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore.js';
import { useTenantConnectionsStore } from '@/stores/TenantConnectionsStore.js';
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';
import DialogModel from '@/components/mixin/DialogModel.js';

export default {
  mixins: [ DialogActionKeys, DialogModel ],
  name: 'AwayTenantCreateDialog',
  data() {
    return {
      isSubmitted: false,

      errorMessage: '',
      successMessage: '',

      connectionCodeInput: '',
      connectionCodeInputRules: [
        v => !!v || this.$t('console.connectionCodeRequired'),
      ],
    };
  },
  watch: {
    dialog(newVal) {
      if (!newVal) {
        this.resetForm();
      }
    },
  },
  methods: {
    resetForm() {
      this.isSubmitted = false;
      this.errorMessage = '';
      this.successMessage = '';

      this.connectionCodeInput = '';
    },
    async submitForm() {
      const { valid } = await this.$refs.form.validate();

      if (!valid) {
        return;
      }

      const formData = {
        connectionCode: this.connectionCodeInput,
      };

      try {
        this.isSubmitted = true;

        const tenantConnectionsStore = useTenantConnectionsStore();
        await tenantConnectionsStore.completeTenantConnection(this.rootNodeId, formData);
        this.dialog = false;
        this.$showMessage(this.$t('console.connectionCompleted'), { type: 'success' });
        await tenantConnectionsStore.refreshAwayTenantsList(this.rootNodeId);
      } catch (error) {
        console.error(error);

        if (error?.response?.data?.error) {
          this.errorMessage = this.$localizeMessage(error.response.data.error);
        } else {
          this.errorMessage = this.$t('backend.system-error');
        }
      } finally {
        this.isSubmitted = false;
      }
    },
  },
  computed: {
    rootNodeId: function () {
      const authStore = useAuthStore();
      return authStore.rootNodeId;
    },
  },
};
</script>
